import { AuthSessionMissingError, SupabaseClient, User } from '@supabase/supabase-js'
import { Database } from "@/supabase/types"
import { createIsomorphicLogger } from '@/utils/logger/isomorphicLogger'
import { logError } from '@/utils/errorLogging'
import { Groups } from '@/types/base/authuser'
import { getGroupById } from '../groups'
import { getUserById } from '@/lib/server/create-user'

const logger = createIsomorphicLogger('auth.users')

export const getAuthUser = async (supabase: SupabaseClient<Database>, silent: boolean = false): Promise<User | null> => {
	const userResponse = await supabase.auth.getUser()
	let errorReported = false

  if (userResponse.error) {
		errorReported = true
		if (userResponse.error instanceof AuthSessionMissingError) {
			if (!silent) {
				logger.info('User session missing')
			}
		}
		else {
			logError(logger, userResponse.error, 'Failed to retrieve authenticated user')
		}
  }

	const user = userResponse.data.user

  if (!user && !silent && !errorReported) {
		logger.error('User not found with no error reported')
  }

  return user
}

/**
	Note that this function returns the assigned tenant_id based on the user metadata and might not be
	indicative of a user without a tenantUser entry
 */
export const getUserTenant = async (supabase: SupabaseClient<Database>, uid: string) => {
	const user = await getUserById(uid)

	if (user) {
		const groups: Groups = user.app_metadata.groups
		const loginGroups: Array<string> = []

		for (const grpId in groups) {
			const grpObj = groups[grpId]
			const res = grpObj.filter((roleName: string) => roleName == 'login')
			if (res.length != 0) {
				loginGroups.push(grpId)
			}
		}

		if (loginGroups.length == 1) {
			const group = await getGroupById(supabase, loginGroups[0])
			return group.tenant_id
		}
	}
	return null
}
